export class Profile {
  id?: number;
  username: string;
  bio: string;
  image: string;
  following: boolean;
}
